import Vue from 'vue'
import DialogBox from './DialogBox'

//import { use, registerComponent, registerComponentProgrammatic } from '../../utils/plugins'

const DialogBoxProgrammatic = {
    open(params) {
        let content
        let parent
        if (typeof params === 'string') content = params
        const defaultParam = {
            programmatic: true,
            content
        }
        if (params.parent) {
            parent = params.parent
            delete params.parent
        }
        const propsData = Object.assign(defaultParam, params)

        const vm = typeof window !== 'undefined' && window.Vue ? window.Vue : Vue
        const DialogBoxComponent = vm.extend(DialogBox)
        return new DialogBoxComponent({
            parent,
            el: document.createElement('div'),
            propsData
        })
    }
}

const Plugin = {
    install(Vue) {
        //registerComponent(Vue, Modal)
        Vue.prototype.$DialogBox = DialogBoxProgrammatic
        //registerComponentProgrammatic(Vue, '$modal', ModalProgrammatic)
    }
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
}

export default Plugin

export {
    //Modal,
    DialogBoxProgrammatic
}